export default "/images/bonus.png?2b5aabfb1daec1f8f8aa69aa61102f75";